import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}

const RenewalPaymentFailureAccountAlert: React.FC<Props> = ({ alert }) => {
  const { t } = useTranslation()

  if (!alert.subscription) {
    return null
  }
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.paymentProblem')}</p>
      <div className="mb-2.5">
        <p>
          {t('content.renewalPaymentProblemExplanation', {
            amount: formatPriceInCents(alert.amount ?? 0, { showDouble0ForCents: true }),
            planName: alert.subscription.displayable_plan_name,
          })}
        </p>
        <ul className="list-disc">
          <li className="pt-2.5">{t('content.paymentProblem1')}</li>
          <li className="pt-2.5">{t('content.paymentProblem2')}</li>
          <li className="pt-2.5">{t('content.paymentProblem3')}</li>
          <li className="pt-2.5">{t('content.paymentProblem4')}</li>
        </ul>
      </div>
    </AlertCard>
  )
}

export default RenewalPaymentFailureAccountAlert
